"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
var constants_1 = require("../constants");
var User = /** @class */ (function () {
    function User(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    Object.defineProperty(User.prototype, "fullName", {
        get: function () {
            return "".concat(this.firstName, " ").concat(this.lastName);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "lastNameFirstName", {
        get: function () {
            return "".concat(this.lastName, ", ").concat(this.firstName);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isStudent", {
        get: function () {
            return (this.roles || []).includes(constants_1.UserRole.Student);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isTeacher", {
        get: function () {
            return (this.roles || []).includes(constants_1.UserRole.Teacher);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isAuthor", {
        get: function () {
            return (this.roles || []).includes(constants_1.UserRole.Author);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isDistrictAdmin", {
        get: function () {
            return (this.roles || []).includes(constants_1.UserRole.DistrictAdmin);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isSchoolAdmin", {
        get: function () {
            return (this.roles || []).includes(constants_1.UserRole.SchoolAdmin);
        },
        enumerable: false,
        configurable: true
    });
    return User;
}());
exports.User = User;
